<template>
  <div class="login-container">
    <!-- <img src="bird-logo.png" class="birdLogo" alt="" /> -->

    <div class="maxxifiedLogoContainer">
      <img :src="tenantConfigs?.logo ? tenantConfigs?.logo : maxxifiedLogo" class="newLogo" alt="" />
    </div>

    <p class="loginTitleNew">Login</p>
    <p class="loginSuitTitleNew">Authenticate Your Login</p>

    <div class="login-card2">
      <div class="login-card-inner-section">
        <custom-input :label="$t('validation.otp_label')" type="number" :placeholder="$t('validation.otp_placeholder')" :value="otp" @update:value="otp = $event" required :error="error" />

        <div class="buttonDiv">
          <custom-button :disabled="loading" @click="verifyOtp">
            Login
            <div v-if="loading" class="spinner-border text-white spinner-grow-sm" role="status"></div>
          </custom-button>
        </div>

        <!-- Resend OTP Button -->
        <div class="buttonDiv" style="margin-top: 10px">
          <custom-button :disabled="resendDisabled" @click="handleResendOtp">
            {{ resendDisabled ? `Resend OTP in ${resendTimer}s` : 'Resend OTP' }}
          </custom-button>
        </div>
      </div>
    </div>

    <p class="goBackLabel" @click="goBack">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M20 12H4M4 12L10 6M4 12L10 18" stroke="#32393E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      Back
    </p>
    <Footer />
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/authStore'
import { useTenantStore } from '@/stores/tenantStore'
import CustomInput from '../../components/CustomInput.vue'
import CustomButton from '../../components/CustomButton.vue'
import _ from 'lodash'
import { get, post } from '../../utils/api.js'
import { updateThemeColor } from '@/utils/theme.js'
import maxxifiedLogo from '@/assets/vasionLogin.png'
import Footer from '../../components/Footer.vue'

export default {
  data() {
    return {
      otp: '',
      loading: false,
      error: null,
      email: '',
      tenantConfigs: {},
      maxxifiedLogo,
      resendDisabled: true,
      resendTimer: 30,
      resendInterval: null,
    }
  },
  components: {
    CustomInput,
    CustomButton,
    Footer,
  },
  mounted() {
    document.title = 'Vasion IDP OTP Screen'
    this.getTenantConfig()
    this.startResendTimer()
  },
  computed: {
    auth() {
      return useAuthStore()
    },
    tenant() {
      return useTenantStore()
    },
  },
  methods: {
    async getTenantConfig() {
      try {
        const encodedEmail = localStorage.getItem('email')
        const response = await get(`public/tenant-config?key=email&value=${encodedEmail}`)
        console.log('response', response)
        const config = response.data.data || {}
        this.tenantConfigs = config
        const { selected_theme, theme_primary_color, theme_secondary_color, custom_primary_color, custom_secondary_color } = config
        const primary = selected_theme === 'Custom' ? custom_primary_color : theme_primary_color
        const secondary = selected_theme === 'Custom' ? custom_secondary_color : theme_secondary_color
        if (primary) localStorage.setItem('theme_primary_color', primary)
        if (secondary) localStorage.setItem('theme_secondary_color', secondary)
      } catch (error) {}
    },
    startResendTimer() {
      this.resendDisabled = true
      // Clear any previous interval before starting new
      if (this.resendInterval) clearInterval(this.resendInterval)

      this.resendInterval = setInterval(() => {
        if (this.resendTimer > 0) {
          this.resendTimer--
        } else {
          this.resendDisabled = false
          clearInterval(this.resendInterval)
          this.resendInterval = null
          this.resendTimer = 30
        }
      }, 1000)
    },

    async handleResendOtp() {
      if (this.resendDisabled) return // guard

      this.resendDisabled = true // disable button immediately
      try {
        const email = localStorage.getItem('email')
        await post('auth/resend-otp', { email })

        this.startResendTimer() // start 30s countdown
      } catch (err) {
        this.resendDisabled = false // enable button on error
      }
    },
    goBack() {
      this.$router.push('/login')
    },

    verifyOtp: _.debounce(async function () {
      this.error = null

      if (!this.otp) {
        this.error = 'OTP is required'
        return
      }

      this.loading = true
      const session = localStorage.getItem('session')
      const email = localStorage.getItem('email')

      try {
        const response = await this.auth.verifyOTP(email, this.otp, session)
        if (response?.data?.data?.user?.is_active === false) {
          this.error = 'Your account is not active. Please contact your administrator.'
          return
        } else if (response?.data?.code === 200) {
          this.error = null
          console.log('response123123', response?.data?.data?.user)
          const language = response?.data?.data?.user?.selected_language_type
          // Store tokens
          const authResult = response.data.data
          localStorage.setItem('AccessToken', authResult?.accessToken)
          localStorage.setItem('IdToken', authResult?.idToken)
          localStorage.setItem('RefreshToken', authResult?.refreshToken)
          if (language) {
            localStorage.setItem('language', language)
            // Set the i18n locale to apply the language immediately
            this.$i18n.locale = language
          }

          // Update auth store
          // this.auth.AccessToken = authResult?.AccessToken
          // this.auth.IdToken = authResult?.IdToken
          // this.auth.RefreshToken = authResult?.RefreshToken

          // Get user data from the correct path in the response
          const userData = response.data.data.user

          if (userData) {
            localStorage.setItem('UserData', JSON.stringify(userData))
            const userId = userData.id
            const tenantId = userData.tenant_id
            const roleResponse = await get(`/v1/user-roles/${userId}`)
            if (roleResponse?.data?.code === 200) {
              localStorage.setItem('UserRoles', JSON.stringify(roleResponse.data.data))
              localStorage.setItem('userRole', roleResponse.data.data[0].role.roleName)
            }
            if (roleResponse?.data?.code === 401) {
              this.error = roleResponse.data.message
              return
            }
            const permissionsResponse = await get(`/v1/users/permissions/${userId}`)
            if (permissionsResponse?.data?.code === 200) {
              localStorage.setItem('permissions', JSON.stringify(permissionsResponse.data.data))
            }

            // Get tenant details using the store
            if (tenantId) {
              await this.tenant.fetchTenantConfigs(tenantId)
              const tenantResponse = await get(`/v1/tenant-configs/tenant/${tenantId}`)
              if (tenantResponse?.data?.code === 200) {
                const tenantConfigs = tenantResponse.data.data
                // Store all tenant configs
                localStorage.setItem('TenantDetails', JSON.stringify(tenantConfigs))

                // Store specific configs separately
                const selectedTheme = tenantConfigs.find((config) => config.key === 'selected_theme')?.value
                const urlName = tenantConfigs.find((config) => config.key === 'url_name')?.value
                const primaryColor = tenantConfigs.find((config) => config.key === 'theme_primary_color')?.value
                const secondaryColor = tenantConfigs.find((config) => config.key === 'theme_secondary_color')?.value
                const custom_primary_color = tenantConfigs.find((config) => config.key === 'custom_primary_color')?.value
                const custom_secondary_color = tenantConfigs.find((config) => config.key === 'custom_secondary_color')?.value

                if (urlName) localStorage.setItem('url_name', urlName)
                if (primaryColor) localStorage.setItem('theme_primary_color', selectedTheme === 'Custom' ? custom_primary_color : primaryColor)
                if (secondaryColor) localStorage.setItem('theme_secondary_color', selectedTheme === 'Custom' ? custom_secondary_color : secondaryColor)
                updateThemeColor(selectedTheme === 'Custom' ? custom_primary_color : primaryColor, selectedTheme === 'Custom' ? custom_secondary_color : secondaryColor)

                if (roleResponse.data.data[0].role.roleName === 'Super Admin') {
                  updateThemeColor('#3d2562', '#f5f4f7')
                }
                // Add a small delay to ensure all storage operations are complete
                // await new Promise(resolve => setTimeout(resolve, 100))
                this.$router.push(`/${urlName}/dashboard`)
              }
            }
          }
        } else {
          this.error = null
          this.error = 'Invalid code, Please enter valid OTP to continue'
        }
      } catch (error) {
        if (error.response.status === 401) {
          this.error = 'Tenant is not active, Please contact your administrator.'
        } else {
          this.error = 'OTP verification failed'
        }
      } finally {
        this.loading = false
      }
    }, 300),
  },
}
</script>

<style scoped>
@import '@/styles/login.css';
</style>
